import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_WORKOUT_TYPES,
    FETCH_WORKOUT_TYPES_FETCHING,
    FETCH_WORKOUT_TYPES_SUCCESS,
    FETCH_WORKOUT_TYPES_FAIL,
    FETCH_WORKOUT_ALL_TYPES_FETCHING,
    FETCH_WORKOUT_ALL_TYPES_SUCCESS,
    FETCH_WORKOUT_ALL_TYPES_FAIL,
    FETCH_WORKOUT_ALL_TYPES
} from 'actions/ActionTypes';
import { isEmpty } from 'utils/ObjectUtil';

export function* fetchWorkoutTypes(action) {
    let filteredWorkoutTypes = [null];
    if (!isEmpty(action.payload.filteredWorkoutTypes)) {
        filteredWorkoutTypes = filteredWorkoutTypes.concat(action.payload.filteredWorkoutTypes);
    }

    try {
        yield put({
            type: FETCH_WORKOUT_TYPES_FETCHING
        });

        const response = yield call(gcApi.get, '/workout-service/workout/types/sport');

        yield put({
            type: FETCH_WORKOUT_TYPES_SUCCESS,
            data: response.data,
            filteredWorkoutTypes: filteredWorkoutTypes
        });
    } catch (e) {
        yield put({
            type: FETCH_WORKOUT_TYPES_FAIL
        });
    }
}

export function* fetchWorkoutEndConditionTypes() {
    try {
        yield put({ type: FETCH_WORKOUT_ALL_TYPES_FETCHING });

        const response = yield call(gcApi.get, '/workout-service/workout/types');
        if (response?.data?.workoutEquipmentTypes && Array.isArray(response?.data?.workoutEquipmentTypes)) {
            response.data.workoutEquipmentTypes = [
                ...response.data.workoutEquipmentTypes,
                {
                    equipmentTypeId: null,
                    equipmentTypeKey: null,
                    displayOrder: null
                }
            ];
        }
        yield put({
            type: FETCH_WORKOUT_ALL_TYPES_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({ type: FETCH_WORKOUT_ALL_TYPES_FAIL });
    }
}

export const workoutTypesSagas = [
    takeEvery(FETCH_WORKOUT_TYPES, fetchWorkoutTypes),
    takeEvery(FETCH_WORKOUT_ALL_TYPES, fetchWorkoutEndConditionTypes)
];
